import React from 'react';

export default function About() {
  return <h2>ℹ️ Acerca de esta App</h2>;
}
